
const scopWhiteTxtSVG = `

<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
 width="99.213px" height="85.039px" viewBox="0 0 99.213 85.039" enable-background="new 0 0 99.213 85.039" xml:space="preserve">
<g>
<g>
<g>
<path fill="#FFFFFF" d="M82.947,20.181c0-0.183-0.09-0.32-0.274-0.411l-1.51-0.688l-0.688-1.514
c-0.046-0.182-0.228-0.271-0.41-0.271c-0.186,0-0.321,0.09-0.412,0.271l-0.688,1.514l-1.556,0.688
c-0.184,0.045-0.273,0.229-0.273,0.411s0.09,0.319,0.273,0.411l1.508,0.689l0.69,1.51c0.046,0.183,0.227,0.273,0.411,0.273
c0.182,0,0.321-0.091,0.411-0.273l0.687-1.51l1.512-0.689C82.814,20.548,82.901,20.363,82.947,20.181"/>
<path fill="#FFFFFF" d="M92.284,25.949c0-0.182-0.094-0.32-0.276-0.412l-1.514-0.688l-0.684-1.51
c-0.046-0.182-0.231-0.275-0.41-0.275c-0.186,0-0.321,0.141-0.412,0.275L88.3,24.805l-1.512,0.688
c-0.183,0.045-0.274,0.23-0.274,0.41c0,0.185,0.092,0.322,0.274,0.416l1.512,0.684l0.688,1.51
c0.043,0.184,0.227,0.276,0.412,0.276c0.179,0,0.364-0.138,0.364-0.229l0.687-1.51l1.513-0.687
C92.145,26.27,92.236,26.087,92.284,25.949"/>
<path fill="#FFFFFF" d="M92.256,13.605c0-0.185-0.092-0.324-0.274-0.412l-1.512-0.689l-0.685-1.51
c-0.046-0.183-0.232-0.274-0.413-0.274c-0.137,0-0.321,0.092-0.412,0.229l-0.686,1.509l-1.512,0.688
c-0.186,0.047-0.273,0.23-0.273,0.414c0,0.181,0.088,0.321,0.273,0.408l1.512,0.689l0.686,1.512
c0.046,0.182,0.227,0.271,0.412,0.271c0.181,0,0.32-0.09,0.413-0.271l0.685-1.512l1.512-0.689
C92.116,13.926,92.256,13.789,92.256,13.605"/>
<path fill="#FFFFFF" d="M9.662,28.78l1.171,5.797c0.131,0.677,0.724,1.138,1.381,1.138c0.092,0,0.187-0.009,0.281-0.028
l4.073-0.819l0.209,1.057c0.135,0.665,0.723,1.133,1.385,1.133c0.05,0,0.104-0.002,0.156-0.01l39.766-4.363l0.427,2.125
c0.079,0.367,0.294,0.689,0.604,0.897c0.234,0.155,0.509,0.235,0.782,0.235c0.096,0,0.188-0.006,0.28-0.025l4.999-1.01
c0.766-0.152,1.26-0.896,1.109-1.662l-0.543-2.691c2.056-0.721,3.815-2.08,5.042-3.927c1.489-2.243,2.021-4.933,1.486-7.571
c-1.003-4.982-5.538-8.369-10.473-8.08l-0.49-2.432c-0.154-0.766-0.897-1.258-1.665-1.106l-4.997,1.006
c-0.368,0.077-0.69,0.294-0.899,0.604c-0.207,0.31-0.281,0.697-0.207,1.063l0.424,2.123L26.855,20.27
c-0.747,0.224-1.175,1.014-0.955,1.759c0.224,0.748,1.012,1.177,1.759,0.956l7.072-2.102l2.271,11.271L19.293,34.1l-0.234-1.17
v-0.004l-1.167-5.802l-0.003-0.006l-0.235-1.169l3.523-1.045c0.749-0.224,1.176-1.01,0.955-1.758
c-0.224-0.749-1.014-1.176-1.759-0.953l-4.761,1.41c-0.703,0.211-1.132,0.918-0.988,1.636l0.217,1.056l-4.072,0.82
c-0.367,0.072-0.691,0.291-0.897,0.602C9.662,28.031,9.588,28.412,9.662,28.78 M65.176,27.746l-2.813-13.965
c1.428-0.004,2.825,0.408,4.04,1.219c1.615,1.073,2.718,2.709,3.097,4.611c0.384,1.9,0.005,3.835-1.069,5.453
C67.624,26.277,66.494,27.199,65.176,27.746 M56.994,12.942v-0.003l-0.4-2.002l2.223-0.449l0.473,2.332v0.004l3.423,16.996v0.005
l0.522,2.591l-2.226,0.449l-0.402-2v-0.002L56.994,12.942z M37.453,20.075l17.073-5.06l3.001,14.889l-17.705,1.941L37.453,20.075
z M12.711,29.604l2.684-0.54l0.612,3.032l-2.684,0.542L12.711,29.604z"/>
<path fill="#FFFFFF" d="M44.729,54.768c-0.526,0-1.016-0.345-1.167-0.879L37.746,33.89c-0.188-0.646,0.184-1.321,0.827-1.509
c0.647-0.192,1.321,0.182,1.512,0.828l5.813,19.999c0.188,0.647-0.184,1.321-0.831,1.51
C44.956,54.749,44.843,54.768,44.729,54.768"/>
<path fill="#FFFFFF" d="M33.102,54.768c-0.113,0-0.228-0.019-0.338-0.045c-0.647-0.193-1.019-0.867-0.831-1.512l5.813-19.998
c0.187-0.65,0.865-1.018,1.51-0.834c0.646,0.189,1.018,0.865,0.83,1.509l-5.813,20.001
C34.117,54.423,33.629,54.768,33.102,54.768"/>
</g>
<text transform="matrix(1 0 0 1 1.6807 74.4092)" fill="#FFFFFF" font-family="HarlowSolid" font-size="16.506">Band Maker</text>
</g>
</g>
</svg>

`;

export default scopWhiteTxtSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/scopWhiteTxtSVG.js